import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { User, Cake } from 'lucide-react';
import './QuickActions.css';

const QuickActions = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Hide on Mon Compte and Admin page to avoid overlapping with dashboard navigation
    if (location.pathname === '/mon-compte' || location.pathname === '/admin') return null;

    return (
        <div className="quick-actions-mobile">
            <button
                className="quick-action-btn shop-btn"
                onClick={() => navigate('/gateaux')}
                aria-label="Nos Gâteaux"
            >
                <Cake size={24} />
            </button>
            <button
                className="quick-action-btn account-btn-float"
                onClick={() => navigate('/mon-compte')}
                aria-label="Mon Compte"
            >
                <User size={24} />
            </button>
        </div>
    );
};

export default QuickActions;
